import React, { Suspense, lazy } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
} from "react-router-dom";

import { ThemeProvider } from "@material-ui/styles";
import { createTheme } from "./themes";

import { themes } from "./constants";

import { ContextWrap as Provider } from "./Context";

import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

import "./app.css";
import "./temp/css/sprite.css";

const SPSCreate = lazy(() => import(
  /* webpackChunkName: "SPSCreate" */
  "./pages/SPSCreate"
));
const SPSDetails = lazy(() => import(
  /* webpackChunkName: "SPSDetails" */
  "./pages/SPSDetails"
));
const SPSList = lazy(() => import(
  /* webpackChunkName: "SPSList" */
  "./pages/SPSList"
));

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    pageWrapper: {
      margin: "20px 20px",
      minWidth: "500px",
    },
  })
);

const SPSApp = (props: any) => {
  const classes = useStyles();
  const { myWorkData } = props;

  const theme = createTheme({
    theme: themes.light,
  });

  return (
    <div className={classes.pageWrapper}>
      <Router>
        <Provider siteConfig={{ NAME: name, ...myWorkData }}>
          <ThemeProvider theme={theme}>
            <Suspense fallback={null}>
              <Routes>
                <Route path="/wb/sps/index" element={<SPSList />} />
                <Route path="/wb/sps/edit/:id" element={<SPSDetails />} />
                <Route path="/wb/sps/add" element={<SPSCreate />} />
              </Routes>
            </Suspense>
          </ThemeProvider>
        </Provider>
      </Router>
    </div>
  );
};

export default SPSApp;
